// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-limiter .MuiTypography-root {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  min-width: 20%;
}

.root-g {
  width: 100%;
  display: flex;
}

.g1 {
  padding-bottom: 26px;
  padding-right: 36px;
}

.g1g2 {
  width: 60%;
  display: flex;
  flex-direction: column;
}

.g3 {
  width: 40%;
  padding-bottom: 20px;
}

@media only screen and (max-width: 1100px) {
  .root-g {
    flex-direction: column;
    width: 100%;
  }

  .g1g2 {
    width: 100%;
  }

  .g1 {
    width: 100%;
    padding-right: 0;
  }

  .g2 {
    width: 100%;
    padding-right: 0;
  }

  .g3 {
    width: 100%;
  }
}

.nav-transaction-id {
  display: flex;
  min-width: 228px;
  border-radius: 8px;
  align-items: center;
  border: 1px solid #d9d9d9;
  padding: 5.2px 6px;
  gap: 15px;
}

.txn-id-copy-btn {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

.copy-button:hover {
  cursor: pointer;
}

.order-category-root {
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 32px;
}

.order-category {
  width: 27.5%;
  padding-top: 24px;
  padding-right: 0.6rem;
}

.order-category:nth-child(3n-2) {
  width: 45%;
  padding-top: 24px;
  padding-right: 0.6rem;
}

@media only screen and (max-width: 502px) {
  .order-category {
    width: 50%;
  }
}

.card-logo {
  width: 44px;
  padding: 0px 11px 0px 11px;
}

.card-logo img {
  width: 14px;
  height: 14px;
}

.card-details {
  width: 100%;
}

.card-amount-info {
  display: flex;
  width: 100%;

  padding: 8px 0px 24px 0px;
}

.card-row {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 16px;
  margin-right: 10%;
}

.card-row-content {
  margin-right: 5%;
}

.card-payment-status {
  display: flex;
  padding: 5px 16px;
  align-items: center;
  gap: 2px;
  border-radius: 12px;
  background: var(--comms-positive-sub, #d5fbd2);
}

.toolTip {
  padding-top: 5px;
}

.card-payment-info {
  display: flex;
  width: 100%;
  flex-direction: column;
}

.card-timeline {
  display: flex;
}

.timeline-details {
  display: flex;
  flex-direction: column;
  padding-left: 20px;
}

.timeline-details-single-component {
  display: flex;
}

.timeline-details-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-right: 12px;
}

.detail-info {
  display: flex;
  align-items: flex-start;
}

.timeline-details-icon img {
  width: 16px;
  height: 16px;
}

.timeline-details-title {
  display: flex;
}

.payment-status-btn {
  display: flex;
  padding: 10px 5px;
  align-items: center;
  justify-content: center;
  gap: 2px;
  border-radius: 8px;
  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);
  min-width: 130px;
  height: 22px;
  margin-left: 8px;
}

.info-circle {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 14px;
  height: 14px;
  margin-left: 8px;
}

.psp-btn {
  border-radius: 12px;
  background: #e7e7ff;
}

.psp-btn img {
  height: 16px;
  width: 16px;
}

.connector-line {
  width: 1px;
  height: 100%;
  background: linear-gradient(90deg,
      #cac9fb 6.78%,
      #cac9fb 57.43%,
      rgba(202, 201, 251, 0.6) 67.76%,
      rgba(255, 255, 255, 0.4) 84.48%,
      #cac9fb 101.2%);
}

.brand-logo-typography {
  display: flex;
  align-items: center;
  gap: 4px;
}

.payment-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 8px;
  padding-right: 8px !important;
  height: 16px;
  width: 24px;
}

.payment-logo img {
  height: 16px;
  width: 24px;
}

.card-number {
  display: flex;
  letter-spacing: 8px;
}

.number-group {
  display: flex;
  padding: 0px 12px 0px 12px;
  justify-content: center;
  align-items: center;
}

.number-group span {
  height: 6px;
  width: 6px;
  background-color: rgba(1, 1, 2, 0.72);
  border-radius: 50%;
  padding-top: 10px;
}

.timeline-subtitles {
  padding-top: 10px;
}

.bck-yellow {
  background: #fbefcb;
}

.bck-green {
  background: var(--comms-positive-sub, #d5fbd2);
}

.bck-red {
  background: var(--comms-negative-sub, #fde3d6);
}

.bck-blue {
  background: #E6F7FF;
}

.refund-capture {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 80px;
  gap: 16px;
}

.refund-btn {
  display: inline-flex;
  padding: 6px 15px;
  justify-content: center;
  align-items: center;
  min-width: 134px;
  height: 32px;
  gap: 8px;
  border-radius: 8px;
  background: var(--generic-primary-accent, #403e9f);
  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.04);
  margin-left: 16px;
}

.refund-btn:hover {
  cursor: pointer;
}

.options-btn {
  display: inline-flex;
  padding: 6px 15px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  min-width: 134px;
  border: 1px solid var(--neutral-5, #d9d9d9);
  background: var(--neutral-1, #fff);
  height: 32px;
  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);
}

.options-btn:hover {
  cursor: pointer;
}

.capture-btn {
  display: inline-flex;
  padding: 6px 15px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  border: 1px solid rgba(64, 62, 159, 1);
  background: var(--neutral-1, #fff);
  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);
}

.capture-btn:hover {
  cursor: pointer;
}

.error {
  display: flex;
  align-items: flex-start;
  margin-top: 5px;
}

.error img {
  margin-right: 4px;
}

.void-btn {
  width: 64px;
  height: 32px;
  margin-right: 16px;
  color: var(--generic-primary-accent, #403e9f);
}

.capture.MuiTypography-root {
  color: var(--character-title-85, rgba(0, 0, 0, 0.85));
}

.refund.MuiTypography-root {
  color: var(--character-primary-inverse, #fff);
}

.options.MuiTypography-root {
  color: var(--character-title-85, rgba(0, 0, 0, 0.85));
}

.otherReasonField .MuiInputBase-root.MuiOutlinedInput-root {
  width: 230px;
  height: 32px;
  margin-top: 12px;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/orderManagement/OrderDetails/orderDetails2.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;;EAEX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,+CAA+C;EAC/C,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,UAAU;EACV,YAAY;EACZ;;;;;qBAKmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,QAAQ;EACR,kBAAkB;EAClB,kDAAkD;EAClD,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,kCAAkC;EAClC,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,sCAAsC;EACtC,kCAAkC;EAClC,+CAA+C;AACjD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":[".text-limiter .MuiTypography-root {\n  display: block;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  min-width: 20%;\n}\n\n.root-g {\n  width: 100%;\n  display: flex;\n}\n\n.g1 {\n  padding-bottom: 26px;\n  padding-right: 36px;\n}\n\n.g1g2 {\n  width: 60%;\n  display: flex;\n  flex-direction: column;\n}\n\n.g3 {\n  width: 40%;\n  padding-bottom: 20px;\n}\n\n@media only screen and (max-width: 1100px) {\n  .root-g {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .g1g2 {\n    width: 100%;\n  }\n\n  .g1 {\n    width: 100%;\n    padding-right: 0;\n  }\n\n  .g2 {\n    width: 100%;\n    padding-right: 0;\n  }\n\n  .g3 {\n    width: 100%;\n  }\n}\n\n.nav-transaction-id {\n  display: flex;\n  min-width: 228px;\n  border-radius: 8px;\n  align-items: center;\n  border: 1px solid #d9d9d9;\n  padding: 5.2px 6px;\n  gap: 15px;\n}\n\n.txn-id-copy-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n}\n\n.copy-button:hover {\n  cursor: pointer;\n}\n\n.order-category-root {\n  display: flex;\n  flex-wrap: wrap;\n  padding-bottom: 32px;\n}\n\n.order-category {\n  width: 27.5%;\n  padding-top: 24px;\n  padding-right: 0.6rem;\n}\n\n.order-category:nth-child(3n-2) {\n  width: 45%;\n  padding-top: 24px;\n  padding-right: 0.6rem;\n}\n\n@media only screen and (max-width: 502px) {\n  .order-category {\n    width: 50%;\n  }\n}\n\n.card-logo {\n  width: 44px;\n  padding: 0px 11px 0px 11px;\n}\n\n.card-logo img {\n  width: 14px;\n  height: 14px;\n}\n\n.card-details {\n  width: 100%;\n}\n\n.card-amount-info {\n  display: flex;\n  width: 100%;\n\n  padding: 8px 0px 24px 0px;\n}\n\n.card-row {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  margin-top: 16px;\n  margin-right: 10%;\n}\n\n.card-row-content {\n  margin-right: 5%;\n}\n\n.card-payment-status {\n  display: flex;\n  padding: 5px 16px;\n  align-items: center;\n  gap: 2px;\n  border-radius: 12px;\n  background: var(--comms-positive-sub, #d5fbd2);\n}\n\n.toolTip {\n  padding-top: 5px;\n}\n\n.card-payment-info {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n}\n\n.card-timeline {\n  display: flex;\n}\n\n.timeline-details {\n  display: flex;\n  flex-direction: column;\n  padding-left: 20px;\n}\n\n.timeline-details-single-component {\n  display: flex;\n}\n\n.timeline-details-icon {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-right: 12px;\n}\n\n.detail-info {\n  display: flex;\n  align-items: flex-start;\n}\n\n.timeline-details-icon img {\n  width: 16px;\n  height: 16px;\n}\n\n.timeline-details-title {\n  display: flex;\n}\n\n.payment-status-btn {\n  display: flex;\n  padding: 10px 5px;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n  border-radius: 8px;\n  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);\n  min-width: 130px;\n  height: 22px;\n  margin-left: 8px;\n}\n\n.info-circle {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 14px;\n  height: 14px;\n  margin-left: 8px;\n}\n\n.psp-btn {\n  border-radius: 12px;\n  background: #e7e7ff;\n}\n\n.psp-btn img {\n  height: 16px;\n  width: 16px;\n}\n\n.connector-line {\n  width: 1px;\n  height: 100%;\n  background: linear-gradient(90deg,\n      #cac9fb 6.78%,\n      #cac9fb 57.43%,\n      rgba(202, 201, 251, 0.6) 67.76%,\n      rgba(255, 255, 255, 0.4) 84.48%,\n      #cac9fb 101.2%);\n}\n\n.brand-logo-typography {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.payment-logo {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-top: 8px;\n  padding-right: 8px !important;\n  height: 16px;\n  width: 24px;\n}\n\n.payment-logo img {\n  height: 16px;\n  width: 24px;\n}\n\n.card-number {\n  display: flex;\n  letter-spacing: 8px;\n}\n\n.number-group {\n  display: flex;\n  padding: 0px 12px 0px 12px;\n  justify-content: center;\n  align-items: center;\n}\n\n.number-group span {\n  height: 6px;\n  width: 6px;\n  background-color: rgba(1, 1, 2, 0.72);\n  border-radius: 50%;\n  padding-top: 10px;\n}\n\n.timeline-subtitles {\n  padding-top: 10px;\n}\n\n.bck-yellow {\n  background: #fbefcb;\n}\n\n.bck-green {\n  background: var(--comms-positive-sub, #d5fbd2);\n}\n\n.bck-red {\n  background: var(--comms-negative-sub, #fde3d6);\n}\n\n.bck-blue {\n  background: #E6F7FF;\n}\n\n.refund-capture {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  height: 80px;\n  gap: 16px;\n}\n\n.refund-btn {\n  display: inline-flex;\n  padding: 6px 15px;\n  justify-content: center;\n  align-items: center;\n  min-width: 134px;\n  height: 32px;\n  gap: 8px;\n  border-radius: 8px;\n  background: var(--generic-primary-accent, #403e9f);\n  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.04);\n  margin-left: 16px;\n}\n\n.refund-btn:hover {\n  cursor: pointer;\n}\n\n.options-btn {\n  display: inline-flex;\n  padding: 6px 15px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 8px;\n  min-width: 134px;\n  border: 1px solid var(--neutral-5, #d9d9d9);\n  background: var(--neutral-1, #fff);\n  height: 32px;\n  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);\n}\n\n.options-btn:hover {\n  cursor: pointer;\n}\n\n.capture-btn {\n  display: inline-flex;\n  padding: 6px 15px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 8px;\n  border: 1px solid rgba(64, 62, 159, 1);\n  background: var(--neutral-1, #fff);\n  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);\n}\n\n.capture-btn:hover {\n  cursor: pointer;\n}\n\n.error {\n  display: flex;\n  align-items: flex-start;\n  margin-top: 5px;\n}\n\n.error img {\n  margin-right: 4px;\n}\n\n.void-btn {\n  width: 64px;\n  height: 32px;\n  margin-right: 16px;\n  color: var(--generic-primary-accent, #403e9f);\n}\n\n.capture.MuiTypography-root {\n  color: var(--character-title-85, rgba(0, 0, 0, 0.85));\n}\n\n.refund.MuiTypography-root {\n  color: var(--character-primary-inverse, #fff);\n}\n\n.options.MuiTypography-root {\n  color: var(--character-title-85, rgba(0, 0, 0, 0.85));\n}\n\n.otherReasonField .MuiInputBase-root.MuiOutlinedInput-root {\n  width: 230px;\n  height: 32px;\n  margin-top: 12px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
